export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Zoeken',
  catalogHeaderTitle: 'Details',
  catalogDetailsCurtainCopyOptionTitle: 'Kopieer link',
  catalogDetailsLinkCopiedAlertText: 'Link gekopieerd!',
  catalogDetailsCurtainFlagOptionTitle: 'Meld inhoud',
  catalogDetailsFlagCurtainTitle: 'Melding',
  catalogReportedCurtainContent: 'Inhoud gemeld',
  catalogWantBuy: 'Wil {item} kopen van {app}',
  catalogInterestedIn: '{link}'
}
